import {
    ComponentConfig,
    LayoutTypes,
    ComponentType,
    FlexDirection,
} from "../services/types/ComponentTypes";

export const screen_168_sales_person: ComponentConfig[] = [
    {
        componentType: LayoutTypes.SCREEN_GROUP,
        fabAction: {
            type: "add",
            screenId: "19",
            action: "modulev1/sales_person_add",
        },
        title: "Sales Agent",
        style: {
            backgroundColor: "#F9FAFB",
        },
        childComponents: [
            {
                componentType: LayoutTypes.GROUP,
                style: {
                    backgroundColor: "#ffffff",
                    direction: FlexDirection.COLUMN,
                    borderRadius: 12,
                    padding: 16,
                },
                childComponents: [
                    {
                        componentType: ComponentType.SUMMARY_LIST,
                        titleValue: "name",
                        Name: "sales_persons_summary",
                        style: {
                            maxHeight: "calc(100vh - 350px)",
                        },
                        SummeryActions: [
                            {
                                Action: {
                                    Action: "Navigate",
                                    Navigate: "modulev1/sales_person_add/<id>",
                                },
                                ActionType: "Edit",
                                ScreenId: "19",
                            },
                            {
                                Action: {
                                    Action: "Delete",
                                    Module: "sales_persons_summary",
                                },
                                ActionType: "Delete",
                                ScreenId: "19",
                            },
                        ],
                        Form: {
                            Name: "sales_persons_summary",
                            TableName: "external_sales_employees",
                            DisplayName: "Sales employee",
                            Fields: [
                                {
                                    IncludeLabel: true,
                                    Label: "id",
                                    BindValue: "id",
                                    Json_Attribute: "id",
                                    componentType: ComponentType.TEXT_FIELD,
                                    showInSummary: false,
                                },
                                {
                                    IncludeLabel: true,
                                    Label: "Name",
                                    BindValue: "name",
                                    Json_Attribute: "name",
                                    componentType: ComponentType.TEXT_FIELD,
                                    showInSummary: true,
                                },
                                {
                                    IncludeLabel: true,
                                    Label: "Mobile",
                                    BindValue: "txt_mobile",
                                    Json_Attribute: "mobile",
                                    componentType: ComponentType.TEXT_FIELD,
                                    showInSummary: true,
                                },
                                {
                                    IncludeLabel: true,
                                    Label: "Created at",
                                    BindValue: "purchase_date",
                                    Json_Attribute: "created_at",
                                    componentType: ComponentType.DATE_FIELD,
                                    showInSummary: true,
                                },
                            ],
                        },
                    },
                ],
            },
        ],
    },
];
